/* eslint-disable import/prefer-default-export */
import { IconBar } from './IconBar';

export const Footer = () => (
  <footer className="fixed-bottom m-2">
    <IconBar />
  </footer>
);
